import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import { AnimatePresence } from "framer-motion"
import ArrowSvg from "src/assets/Arrow-down.svg"
import flagPL from "src/assets/flag_pol.svg"
import flagEN from "src/assets/flag_eng.svg"
import flagLT from "src/assets/lt.svg"

import { getLangFromPath, getRoutesQuery } from "src/utils"
import {
  SelectorWrapper,
  Flag,
  Dropdown,
  DropdownElement,
  Arrow,
} from "./styles"

const locales = ["PL", "EN", "LT"]

const LanguageSelector = ({ path, theme }) => {
  const flags = {
    PL: flagPL,
    EN: flagEN,
    LT: flagLT,
  }

  const [selectedLocale, setSelectedLocale] = useState(null)
  const [dropdownVisible, setDropdownVisible] = useState(false)
  const pathLocale = getLangFromPath()
  const [selectedFlag, setSelectedFlag] = useState(null)

  useEffect(() => {
    if (pathLocale) setSelectedLocale(pathLocale)
  }, [path])

  useEffect(() => {
    setSelectedFlag(flags[selectedLocale])
  }, [selectedLocale])

  const languageStrings = {
    PL: "Polski",
    EN: "English",
    LT: "Lietuvis",
  }

  const query = getRoutesQuery()

  const setLocaleInUrl = locale => {
    const currentQuery = query.chapter[pathLocale.toLowerCase()]
    const localeQuery = query.chapter[locale.toLowerCase()]
    if (currentQuery) {
      const currentRoutes = Object.values(currentQuery.navigation)
      const localeRoutes = Object.values(localeQuery.navigation)
      const currentRouteIndex = currentRoutes.findIndex(
        ({ route }) => encodeURI(route.content) === path
      )
      return localeRoutes[currentRouteIndex].route.content
    }
    return path
  }

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible)
  }

  return (
    <SelectorWrapper>
      <Dropdown theme={theme} border={dropdownVisible}>
        <DropdownElement
          key={languageStrings[selectedLocale]}
          onClick={toggleDropdown}
        >
          <Flag src={flags[selectedLocale]} alt={selectedLocale} />
          <Arrow
            theme={theme}
            src={ArrowSvg}
            turned={dropdownVisible}
            alt="toggle dropdown menu"
          />
        </DropdownElement>
        <AnimatePresence>
          {dropdownVisible &&
            locales
              .filter(locale => locale !== selectedLocale)
              .map(locale => (
                <Link
                  to={`${setLocaleInUrl(locale)}`}
                  key={languageStrings[locale]}
                >
                  <DropdownElement
                    onClick={toggleDropdown}
                    initial={{ maxHeight: 10, opacity: 0 }}
                    animate={{ maxHeight: 50, opacity: 1 }}
                    exit={{ maxHeight: 0, opacity: 0 }}
                    transition={{
                      duration: 1,
                      delay: 0,
                      ease: [0.82, 0.0, 0.195, 1.0],
                    }}
                  >
                    <Flag src={flags[locale]} alt={locale} />
                  </DropdownElement>
                </Link>
              ))}
        </AnimatePresence>
      </Dropdown>
    </SelectorWrapper>
  )
}

export default LanguageSelector
